import api from "./api";

export interface AgentMaterialSettingsUpdateRequest {
  agentId: string;
  type: number;
  scene: string;
  publicEnabled: boolean;
  personalEnabled: boolean;
  noteEnabled?: boolean;
  selectedFolders: {
    folderId: number;
    tagIds: number[];
  }[];
}

/** 更新agent模板素材配置 */
export const agentMaterialSettingsUpdate = async ({
  agentId,
  type,
  scene,
  publicEnabled,
  personalEnabled,
  noteEnabled,
  selectedFolders,
}: AgentMaterialSettingsUpdateRequest) => {
  const res = await api.put<unknown>('/agent/material-settings', {
    agent_id: agentId,
    type,
    scene,
    public_enabled: publicEnabled,
    personal_enabled: personalEnabled,
    note_enabled: noteEnabled,
    selected_folders: selectedFolders.map((item) => ({
      folder_id: item.folderId,
      tag_ids: item.tagIds,
    })),
  });
  return res;
}